import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SiteRepresentative from 'src/components/SiteRepresentative';
import SiteRepresentativeInvitePopup from 'src/components/SiteRepresentativeInvitePopup/SiteRepresentativeInvitePopup/';
import { ServiceType } from 'src/components/JobFormSaqTab/constants';
import s from './JobFormManageSAQUser.styles';

const JobFormManageSAQUser = ({
  auth,
  companyTypes,
  job,
  jobId,
  jobStatus,
  currentUserId,
  redirect
}) => {
    const { t } = useTranslation();

    const [jobExternalStakeholders, setJobExternalStakeholders] = useState([]);
    const [showInvitePopup, setShowInvitePopup] = useState(null);
    const [isLoadingJobExternalStakeholders, setIsLoadingJobExternalStakeholders] = useState(false);
    const [triggerRefetchJobExternalStakeholders, setTriggerRefetchJobExternalStakeholders] = useState(0);

    const allExternalUsersId = jobExternalStakeholders?.map(user => user.userId);
    const externalUserResult = allExternalUsersId.length >= 1 ? allExternalUsersId.includes(currentUserId) : false;
    const isExternalStakeholdersEditable = (auth.isClientUser || auth.isFactoryUser || auth.isVendorUser) ? externalUserResult : true;
    
    useEffect(() => {
        if (!isLoadingJobExternalStakeholders) {
            setTriggerRefetchJobExternalStakeholders((trigger) => trigger + 1);
        }
    }, [jobStatus]);

    
  const SAQInvitePopup = () => {
    return (
      <SiteRepresentativeInvitePopup
        jobId={jobId}
        jobExternalStakeholders={jobExternalStakeholders}
        isLoadingJobExternalStakeholders={isLoadingJobExternalStakeholders}
        onSubmit={() => setTriggerRefetchJobExternalStakeholders((trigger) => trigger + 1)}
        onClose={() => setShowInvitePopup(false)}
        auth={auth}
        job={job}
        companyTypes={companyTypes}
        serviceType={'saq'}
      />
    );
  }

    return (
        <s.Wrapper id="manage-saq-user-tab-content">            
            {showInvitePopup && SAQInvitePopup()}
            <SiteRepresentative setIsLoadingJobExternalStakeholders={setIsLoadingJobExternalStakeholders}
                                setJobExternalStakeholdersData={(data) => setJobExternalStakeholders(data)}
                                showInvitePopupWindow={() => setShowInvitePopup(true)}
                                jobId={jobId} serviceType={ServiceType}
                                triggerRefetchJobExternalStakeholders={triggerRefetchJobExternalStakeholders}
                                isEditable={!auth.isAdmin && auth.isReportReviewer ? false : isExternalStakeholdersEditable}
                                className={'saqExternalUserWrapper'}
                                redirect={redirect}
                                currentUserId={currentUserId}
                                 />
        </s.Wrapper>
    );
};

JobFormManageSAQUser.propTypes = {};

export default React.memo(JobFormManageSAQUser);
